import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import MainLayout from "./layouts/MainLayout";
import Home from "./pages/Home";
import HamdanTransport from "./pages/HamdanTransport";
import HamdanTyres from "./pages/HamdanTyres";
import HamdanPlaza from "./pages/HamdanPlaza";
import HamdanConstruction from "./pages/HamdanConstruction";
import HamdanTravel from "./pages/HamdanTravel";
import HamdanExchange from "./pages/HamdanExchange";
import HamdanMining from "./pages/HamdanMining";
import ALBazRealEstate from "./pages/ALBazRealEstate";
import AlYasminah from "./pages/AlYasminah";
import HamdanGabbroQatar from "./pages/HamdanGabbroQatar";
import ScrollToTop from "./pages/ScrollToTop";

// ✅ Rename import to PascalCase (recommended)
import ContactPage from "./pages/ContactPage";

// ✅ Careers import
import Careers from "./components/CareersPage/Careers";
import JobPortal from "./pages/JobPortal";
import JobPortalLanding from "./pages/JobPortalLanding";
import JobLegal from "./pages/JobLegal";
import About from "./pages/About";
import AdminLogin from "./pages/admin/AdminLogin";
import AdminDashboard from "./pages/admin/AdminDashboard";
import AdminProfile from "./pages/admin/AdminProfile";
import AdminHeader from "./pages/admin/AdminHeader";
import AdminFooter from "./pages/admin/AdminFooter";
import AdminContact from "./pages/admin/AdminContact";
import AdminConstruction from "./pages/admin/AdminConstruction";
import AdminExchange from "./pages/admin/AdminExchange";
import AdminGabbro from "./pages/admin/AdminGabbro";
import AdminMining from "./pages/admin/AdminMining";
import AdminPlaza from "./pages/admin/AdminPlaza";
import AdminRealEstate from "./pages/admin/AdminRealEstate";
import AdminTyres from "./pages/admin/AdminTyres";
import AdminTravel from "./pages/admin/AdminTravel";
import AdminTransport from "./pages/admin/AdminTransport";
import AdminAbout from "./pages/admin/AdminAbout";
import AdminCareers from "./pages/admin/AdminCareers";
import AdminAlYasminah from "./pages/admin/AdminAlYasminah";

// HR Imports
import HRLogin from "./pages/hr/HRLogin";
import HRDashboard from "./pages/hr/HRDashboard";



import "swiper/css";
import "swiper/css/effect-fade";
import "swiper/css/pagination";

const App: React.FC = () => {
  return (
    <Router>
      <ScrollToTop />

      <Routes>
        {/* Admin Routes */}
        <Route path="/admin/login" element={<AdminLogin />} />
        <Route path="/admin/dashboard" element={<AdminDashboard />} />
        <Route path="/admin/profile" element={<AdminProfile />} />
        <Route path="/admin/header" element={<AdminHeader />} />
        <Route path="/admin/footer" element={<AdminFooter />} />
        <Route path="/admin/contact" element={<AdminContact />} />
        <Route path="/admin/construction" element={<AdminConstruction />} />
        <Route path="/admin/exchange" element={<AdminExchange />} />
        <Route path="/admin/gabbro" element={<AdminGabbro />} />
        <Route path="/admin/mining" element={<AdminMining />} />
        <Route path="/admin/plaza" element={<AdminPlaza />} />
        <Route path="/admin/realestate" element={<AdminRealEstate />} />
        <Route path="/admin/tyres" element={<AdminTyres />} />
        <Route path="/admin/travel" element={<AdminTravel />} />
        <Route path="/admin/transport" element={<AdminTransport />} />
        <Route path="/admin/about" element={<AdminAbout />} />
        <Route path="/admin/careers" element={<AdminCareers />} />
        <Route path="/admin/alyasminah" element={<AdminAlYasminah />} />

        {/* HR Routes */}
        <Route path="/hr/login" element={<HRLogin />} />
        <Route path="/hr/dashboard" element={<HRDashboard />} />

        {/* Job Portal Specific Routes (NO MAIN LAYOUT) */}
        <Route path="/job-portal" element={<JobPortalLanding />} />
        <Route path="/job-portal/jobs" element={<JobPortal />} />
        <Route path="/job-portal/legal" element={<JobLegal />} />

        {/* Public Routes */}
        <Route path="*" element={
          <MainLayout>
            <Routes>
              {/* Home */}
              <Route path="/" element={<Home />} />

              {/* About */}
              <Route path="/about" element={<About />} />

              {/* Contact ✅ */}
              <Route path="/contact" element={<ContactPage />} />

              {/* Company pages */}
              <Route path="/hamdan-transport" element={<HamdanTransport />} />
              <Route path="/hamdan-tyres" element={<HamdanTyres />} />
              <Route path="/hamdan-construction" element={<HamdanConstruction />} />
              <Route path="/al-baz-real-estate" element={<ALBazRealEstate />} />
              <Route path="/" element={<Home />} />
              <Route path="/al-yasminah" element={<AlYasminah />} />
              <Route path="/travel-tourism" element={<HamdanTravel />} />
              <Route path="/hamdan-exchange" element={<HamdanExchange />} />
              <Route path="/hamdan-plaza" element={<HamdanPlaza />} />
              <Route path="/hamdan-mining" element={<HamdanMining />} />
              <Route path="/hamdan-gabbro-qatar" element={<HamdanGabbroQatar />} />

              {/* Careers */}
              <Route path="/careers" element={<Careers />} />
            </Routes>
          </MainLayout>
        } />
      </Routes>
    </Router>
  );
};

export default App;
